import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import Theme from "@adsk/alloy-react-theme";
export var LabelField = styled.label(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ["\n  display: flex;\n  margin-bottom: ", "px;\n"],
      ["\n  display: flex;\n  margin-bottom: ", "px;\n"]
    )),
  Theme.spacing.medium
);
export var LabelText = styled.span(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ["\n  ", ";\n  display: block;\n"],
      ["\n  ", ";\n  display: block;\n"]
    )),
  Theme.typography.bodyMediumBold
);
export var RadioInput = styled.div(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      ["\n  margin-right: ", "px;\n"],
      ["\n  margin-right: ", "px;\n"]
    )),
  Theme.spacing.xSmall
);
export var RadioInputPanel = styled.div(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      ["\n  padding-top: ", "px;\n"],
      ["\n  padding-top: ", "px;\n"]
    )),
  Theme.spacing.xxSmall
);
export var RadioInputLabelPanel = styled.div(
  templateObject_5 ||
    (templateObject_5 = __makeTemplateObject(
      ["\n  padding-left: ", "px;\n"],
      ["\n  padding-left: ", "px;\n"]
    )),
  Theme.spacing.xSmall
);
export var MessageHelpPanel = styled.span(
  templateObject_6 ||
    (templateObject_6 = __makeTemplateObject(
      ["\n  display: block;\n"],
      ["\n  display: block;\n"]
    ))
);
export var MessageHelpLink = styled.a(
  templateObject_7 ||
    (templateObject_7 = __makeTemplateObject(
      [
        "\n  text-decoration: none;\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n",
      ],
      [
        "\n  text-decoration: none;\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n",
      ]
    )),
  Theme.colors.adskBlue500
);
var templateObject_1,
  templateObject_2,
  templateObject_3,
  templateObject_4,
  templateObject_5,
  templateObject_6,
  templateObject_7;
